import React, { FunctionComponent } from 'react'
import styles from './MaxLength.module.sass'
import clsx from 'clsx'

interface Props {
    value?: string,
    max: number,
}

const MaxLength: FunctionComponent<Props> = props => {
    const length = props.value?.length ?? 0
    const left = props.max - length < 0 ? 0 : props.max - length

    return <div className={styles.element}>
        <div>{props.children}</div>
        <div className={styles.count}>
            Осталось символов: <span className={clsx({ [styles.warning]: left < 10 })}>{left}</span>
        </div>
    </div>
}

export default MaxLength